/* Manufaktur Rocca - Produktseiten. Drei Teile:
   1) Initialen + Sondermass (nur wo der Block #mr-extra vorhanden ist)
   2) Optionen wie "Schnalle" bekommen das Variantenbild als Auswahlbild
   3) Bundweiten ab 125 cm werden als Uebergroessen abgesetzt */

/* --- 1) Initialen, Sondermass, Zusammenfassung ------------------------- */
(function(){
  var box = document.getElementById('mr-extra');
  if(!box) return;
  var form = document.querySelector('form[action*="/cart/add"]');
  var init = document.getElementById('mr-init');
  var zw   = document.getElementById('mr-zw');
  var warn = document.getElementById('mr-warn');
  var liste= document.getElementById('mr-sum-list');

  function einhaengen(){
    if(!form) return;
    var knopf = form.querySelector('[data-add-to-cart]');
    var ziel  = form.querySelector('.product__submit__holder')
             || (knopf && knopf.closest('.product__submit__buttons'))
             || knopf;
    if(ziel && ziel.parentNode) ziel.parentNode.insertBefore(box, ziel);
    else form.appendChild(box);
  }
  einhaengen();
  setTimeout(function(){ if(form && !form.contains(box)) einhaengen(); }, 1200);

  /* Reihenfolge: erst die Wunsch-Bundweite, danach die Initialen.
     Das Sondermass gehoert direkt unter die Bundweiten-Kacheln. */
  (function sortieren(){
    var felder = box.querySelectorAll('.mr-field');
    if(felder.length < 2) return;
    var initFeld = init && init.closest('.mr-field');
    var zwFeld   = zw   && zw.closest('.mr-field');
    if(initFeld && zwFeld && initFeld.compareDocumentPosition(zwFeld) & Node.DOCUMENT_POSITION_FOLLOWING){
      zwFeld.parentNode.insertBefore(zwFeld, initFeld);
    }
  })();

  if(init) init.addEventListener('input', function(){
    init.value = init.value.replace(/[^A-Za-zÄÖÜäöüß]/g,'').toUpperCase().slice(0,2);
    aktualisieren();
  });
  if(zw) zw.addEventListener('input', function(){
    zw.value = zw.value.replace(/[^0-9]/g,'').slice(0,3);
    aktualisieren();
  });

  /* Bundweiten-Kacheln des Produkts, einmal einlesen.
     Text aus dem eigenen Block wird dabei nie mitgezaehlt. */
  var stufen = null;
  function kacheln(){
    if(stufen) return stufen;
    var raum = (form && form.querySelector('.product__selectors')) || form;
    var gefunden = [];
    if(raum) raum.querySelectorAll('*').forEach(function(el){
      if(el.children.length || box.contains(el)) return;
      var t = (el.textContent || '').trim().match(/^(\d{2,3}) cm$/);
      if(t) gefunden.push(parseInt(t[1],10));
    });
    stufen = [...new Set(gefunden)].sort(function(a,b){ return a-b; });
    return stufen;
  }
  function naechste(n){
    var s = kacheln();
    if(!s.length) return null;
    return s.reduce(function(p,c){ return Math.abs(c-n) < Math.abs(p-n) ? c : p; });
  }

  /* Erlaubte Spanne: 10 cm unter der kleinsten Kachel bis zur groessten Kachel.
     Die groesste Kachel ist 140 cm, das ist die Grenze der Lederhaut.
     Nach oben wird nichts mehr aufgeschlagen. */
  var kl = kacheln();
  var MIN = kl.length ? kl[0] - 10 : 70;
  var MAX = kl.length ? kl[kl.length - 1] : 140;
  var spanne = box.querySelectorAll('.mr-lab em')[1];
  if(spanne) spanne.textContent = MIN + ' bis ' + MAX + ' cm';

  function aktualisieren(){
    var n = parseInt(zw.value, 10);
    var gueltig = zw.value !== '' && n >= MIN && n <= MAX;

    if(gueltig){
      var nah = naechste(n);
      warn.hidden = false;
      warn.className = 'mr-warn mr-warn--info';
      warn.innerHTML = nah
        ? 'Gefertigt wird <b>' + n + ' cm</b>. Wähle oben bitte zusätzlich die nächstliegende Kachel <b>' + nah + ' cm</b>, sie bestimmt nur den Preis.'
        : 'Gefertigt wird <b>' + n + ' cm</b>. Wähle oben bitte zusätzlich die nächstliegende Bundweite, sie bestimmt nur den Preis.';
    } else if(zw.value !== ''){
      warn.hidden = false;
      warn.className = 'mr-warn';
      warn.innerHTML = 'Ich fertige von <b>' + MIN + '</b> bis <b>' + MAX + ' cm</b>. Brauchst du ein anderes Maß, ruf mich bitte vorher kurz an: <a href="tel:+491789799921">0178 9799921</a>.';
    } else {
      warn.hidden = true;
    }

    liste.innerHTML = [
      ['Initialen', init.value ? init.value : 'keine'],
      ['Sondermaß', zw.value === '' ? 'keines, Kachel gewählt' : (n + ' cm' + (gueltig ? '' : ' (bitte prüfen)'))]
    ].map(function(r){ return '<dt>' + r[0] + '</dt><dd>' + r[1] + '</dd>'; }).join('');
  }

  document.addEventListener('change', function(e){
    if(e.target.closest && e.target.closest('form[action*="/cart/add"]')) aktualisieren();
  });
  aktualisieren();
})();

/* --- 2) Bildauswahl fuer Optionen wie Schnalle ------------------------- */
(function(){
  var form = document.querySelector('form[action*="/cart/add"]');
  var quelle = document.querySelector('[data-product-json]');
  if(!form || !quelle) return;
  var produkt;
  try { produkt = JSON.parse(quelle.textContent); } catch(e){ return; }
  if(!produkt || !produkt.variants || !produkt.variants.length) return;

  /* Optionen, die so bleiben wie sie sind */
  var AUS = ['farbe','farben','bundweite','bunweite','größe','grösse','grosse','size','title','innenmaß armband','stückzahl'];

  function auswahl(){
    var a = [];
    form.querySelectorAll('[data-single-option-selector]').forEach(function(el){
      if((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var i = parseInt(String(el.getAttribute('data-index')).replace('option',''), 10) - 1;
      if(i >= 0) a[i] = el.value;
    });
    return a;
  }

  function klein(src){
    return src.replace(/(\.(?:jpg|jpeg|png|webp))(\?|$)/i, '_200x$1$2');
  }

  /* Positionen der Farboption. Hier muss die Variante exakt passen,
     sonst zeigt die Kachel das Leder einer anderen Farbe. */
  var FARBNAMEN = ['farbe', 'farben'];
  var farbPos = [];
  (produkt.options || []).forEach(function(o, i){
    var n = (typeof o === 'string' ? o : (o && o.name) || '').trim().toLowerCase();
    if(FARBNAMEN.indexOf(n) > -1) farbPos.push(i);
  });

  /* Bild der Variante, die diesen Wert hat und sonst am besten zur
     aktuellen Auswahl passt. Die Lederfarbe muss stimmen - gibt es fuer
     die gewaehlte Farbe kein Foto, bleibt die Kachel leer. */
  function bild(p, wert, sel){
    var best = null, score = -1;
    for(var i = 0; i < produkt.variants.length; i++){
      var v = produkt.variants[i];
      if(!v.options || v.options[p] !== wert) continue;
      var passt = true;
      for(var f = 0; f < farbPos.length; f++){
        var fp = farbPos[f];
        if(fp !== p && sel[fp] != null && v.options[fp] !== sel[fp]){ passt = false; break; }
      }
      if(!passt) continue;
      var src = v.featured_image && v.featured_image.src;
      if(!src) continue;
      var s = 0;
      for(var j = 0; j < v.options.length; j++){
        if(j !== p && v.options[j] === sel[j]) s++;
      }
      if(s > score){ score = s; best = src; }
    }
    return best;
  }

  var gruppen = [];
  form.querySelectorAll('.selector-wrapper[data-option-position]').forEach(function(wrap){
    var p = parseInt(wrap.getAttribute('data-option-position'), 10) - 1;
    var lg = wrap.querySelector('.radio__legend__label');
    var name = lg ? lg.textContent.trim().toLowerCase() : '';
    if(!name || AUS.indexOf(name) > -1) return;
    var knoepfe = wrap.querySelectorAll('.radio__button');
    if(knoepfe.length < 2) return;
    /* Einmal pruefen, ob diese Option ueberhaupt eigene Bilder hat.
       Der Kachel-Modus bleibt danach stabil, egal welche Farbe gewaehlt ist. */
    var alle = {};
    produkt.variants.forEach(function(v){
      if(!v.options || v.options[p] == null) return;
      var src = v.featured_image && v.featured_image.src;
      if(src) alle[v.options[p] + "|" + src] = 1;
    });
    var motive = {};
    Object.keys(alle).forEach(function(k){ motive[k.split("|").slice(1).join("|")] = 1; });
    if(Object.keys(motive).length < 2) return;
    gruppen.push({ wrap: wrap, p: p, knoepfe: knoepfe });
  });
  if(!gruppen.length) return;

  function malen(){
    var sel = auswahl();
    gruppen.forEach(function(g){
      var bilder = [];
      g.knoepfe.forEach(function(k){
        var inp = k.querySelector('input');
        bilder.push(inp ? bild(g.p, inp.value, sel) : null);
      });
      /* Kachel-Modus bleibt an, auch wenn fuer diese Farbe nur ein Foto da ist.
         Leere Felder werden als gestricheltes Kaestchen gezeigt. */
      g.wrap.classList.add('mr-bildwahl');
      g.knoepfe.forEach(function(k, i){
        var lab = k.querySelector('label');
        if(!lab) return;
        var feld = lab.querySelector('.mr-bild');
        if(!feld){
          feld = document.createElement('span');
          feld.className = 'mr-bild';
          lab.insertBefore(feld, lab.firstChild);
        }
        feld.style.backgroundImage = bilder[i] ? 'url(' + klein(bilder[i]) + ')' : '';
        feld.classList.toggle('mr-bild--leer', !bilder[i]);
      });
    });
  }

  malen();
  form.addEventListener('change', function(e){
    if(e.target && e.target.hasAttribute && e.target.hasAttribute('data-single-option-selector')){
      setTimeout(malen, 0);
    }
  });
})();

/* --- 3) Bundweiten ab 125 cm abgesetzt als Uebergroessen ---------------- */
(function(){
  var form = document.querySelector('form[action*="/cart/add"]');
  if(!form) return;
  var AB = 125;
  function bauen(){
    form.querySelectorAll('.selector-wrapper[data-option-position]').forEach(function(wrap){
      var lg = wrap.querySelector('.radio__legend__label');
      if(!lg) return;
      var name = lg.textContent.trim().toLowerCase();
      if(name !== 'bundweite' && name !== 'bunweite') return;
      if(wrap.querySelector('.mr-ueber')) return;

      var gross = [];
      wrap.querySelectorAll('.radio__button').forEach(function(k){
        var inp = k.querySelector('input');
        var n = inp && parseInt(inp.value, 10);
        if(n && n >= AB) gross.push(k);
      });
      if(!gross.length) return;

      var feld = wrap.querySelector('.radio__fieldset') || wrap;
      var kasten = document.createElement('div');
      kasten.className = 'mr-ueber';
      kasten.innerHTML =
        '<p class="mr-ueber__titel">Übergrößen</p>' +
        '<p class="mr-ueber__hinweis">Ab 125 cm kommt ein Aufschlag dazu: mehr Leder aus der Haut und mehr Arbeit beim Zuschnitt und in der Verarbeitung. Der Preis oben passt sich an, sobald du wählst.</p>';
      var reihe = document.createElement('div');
      reihe.className = 'mr-ueber__reihe';
      gross.forEach(function(k){ reihe.appendChild(k); });
      kasten.appendChild(reihe);
      feld.appendChild(kasten);
    });
  }
  bauen();
  setTimeout(bauen, 800);
})();
